import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context) {
	var base = '.b-candidatSlider';

	$(base, context).each(function(i, el){
		var $el = $(el);
		var lines = $el.find('.b-candidatLines');

		function updateClasses(item) {
			var firstLine = lines.find('.b-candidatLines-item:first-child');
			var secondLine = lines.find('.b-candidatLines-item:nth-child(2)');
			var thirdLine = lines.find('.b-candidatLines-item:nth-child(3)');

			if (item.activeIndex === 0) {
				firstLine.removeClass('m-animate');
				secondLine.removeClass('m-animate');
				secondLine.removeClass('m-animate-decline');
				thirdLine.removeClass('m-animate');
			} else if ( item.activeIndex === 1 ) {
				firstLine.addClass('m-animate');
				secondLine.removeClass('m-animate-decline');
				secondLine.removeClass('m-animate');
				thirdLine.removeClass('m-animate');
			} else if ( item.activeIndex === 2 ) {
				secondLine.addClass('m-animate-decline');
				firstLine.addClass('m-animate');
				secondLine.removeClass('m-animate');
				thirdLine.removeClass('m-animate');
			} else if ( item.activeIndex === 3 ) {
				thirdLine.addClass('m-animate');
				secondLine.removeClass('m-animate');
				secondLine.addClass('m-animate-decline');
				firstLine.addClass('m-animate');
			} else if ( item.activeIndex === 4 ) {
				secondLine.addClass('m-animate');
				thirdLine.addClass('m-animate');
				secondLine.addClass('m-animate');
				firstLine.addClass('m-animate');
			}
		}

		new Swiper(el.querySelector('.b-candidatSlider-thumbs'), {
			spaceBetween: 0,
			slidesPerView: 1,
			watchOverflow: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			slideClass: 'b-candidatSlider-thumb',
			autoplay: {
				delay: 5000,
			},
			pagination : {
				el : el.querySelector('.swiper-pagination'),
				clickable: true,
			},
			breakpoints: {
				1024: {
					slidesPerView: 1,
					navigation : {
						nextEl : el.querySelector('.b-sliderArrows-btn_next'),
						prevEl : el.querySelector('.b-sliderArrows-btn_prev')
					},
				}
			},
			on: {
				init: function() {
					updateClasses(this);
				},
				transitionEnd: function() {
					updateClasses(this);
				},
			},
		});
	});
});
